import YoutubeVideoElement from "youtube-video-element/react";
import Youtube from "@tiptap/extension-youtube";
import {
	NodeViewWrapper,
	ReactNodeViewRenderer,
	type NodeViewProps,
} from "@tiptap/react";
import { memo } from "react";
import MediaThemeSutro from "player.style/sutro/react";
import { useRouteContext } from "@tanstack/react-router";

export function youtubeParser(url: string) {
	const regExp =
		/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;

	const match = url.match(regExp);

	return match && match[7].length === 11 ? match[7] : null;
}

function Embed({ src }: { src: string }) {
	const { club } = useRouteContext({ from: "__root__" });

	const primaryColor = club?.colors?.primary || "#ffffff";

	return (
		<div className="w-full max-w-full items-center">
			<MediaThemeSutro
				style={{
					// @ts-expect-error - ts cannot cast css variables in style tag
					"--media-primary-color": "#ffffff",
					"--media-secondary-color": primaryColor,
				}}
			>
				<YoutubeVideoElement slot="media" src={src} playsInline />
			</MediaThemeSutro>
		</div>
	);
}

const MemoedEmbed = memo(Embed);

const YoutubeRendererMemoed = memo(MemoedEmbed);

function YoutubeComponent({ node }: NodeViewProps) {
	return (
		<NodeViewWrapper>
			<div className="flex w-full items-center justify-center">
				<YoutubeRendererMemoed src={node.attrs.src} />
			</div>
		</NodeViewWrapper>
	);
}

export const YoutubeExtension = Youtube.extend({
	renderHTML({ HTMLAttributes }) {
		return [
			"div",
			{
				class: "aspect-video max-w-full",
				...HTMLAttributes,
			},
			["iframe", HTMLAttributes],
		];
	},

	addNodeView() {
		return ReactNodeViewRenderer(YoutubeComponent);
	},
});
